"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsSection = NotificationsSection;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("api"));
const NotificationTypesTable_1 = require("./NotificationTypesTable");
function NotificationsSection() {
    const [notificationTypesSettings, setNotificationTypesSettings] = react_1.default.useState(null);
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    function showSuccessSaveNotification() {
        antd_1.notification.success({
            message: intl.formatMessage({ id: 'general.successfuly_saved' }),
            placement: 'bottomRight',
        });
    }
    function showErrorNotification() {
        antd_1.notification.error({
            message: intl.formatMessage({ id: 'general.something_went_wrong' }),
            placement: 'bottomRight',
        });
    }
    async function fetchAndSetNotificationTypesSettings() {
        setIsLoading(true);
        try {
            const settings = await Api.Account.getMyNotificationTypeSettings();
            setNotificationTypesSettings(settings);
        }
        catch (err) {
            showErrorNotification();
        }
        finally {
            setIsLoading(false);
        }
    }
    async function saveNotificationTypesSettings(settings) {
        if (!settings) {
            return;
        }
        setIsLoading(true);
        try {
            await Api.Account.updateMyNotificationTypeSettings(settings);
            showSuccessSaveNotification();
        }
        catch (err) {
            showErrorNotification();
        }
        finally {
            setIsLoading(false);
        }
    }
    const setTypePropertyValue = (value, property, notificationType) => {
        setNotificationTypesSettings(currentSettings => {
            const currentSettingsCopy = JSON.parse(JSON.stringify(currentSettings));
            currentSettingsCopy[notificationType][property] = value;
            if (property === 'is_enabled' && value === false) {
                currentSettingsCopy[notificationType].should_send_email = false;
            }
            if (property === 'should_send_email' && value === true) {
                currentSettingsCopy[notificationType].is_enabled = true;
            }
            return currentSettingsCopy;
        });
    };
    const turnOffAllNotifications = () => {
        const settingsWithAllNotificationsTurnedOff = JSON.parse(JSON.stringify(notificationTypesSettings));
        Object.keys(settingsWithAllNotificationsTurnedOff).forEach(k => {
            settingsWithAllNotificationsTurnedOff[k].is_enabled = false;
            settingsWithAllNotificationsTurnedOff[k].should_send_email = false;
        });
        setNotificationTypesSettings(settingsWithAllNotificationsTurnedOff);
        saveNotificationTypesSettings(settingsWithAllNotificationsTurnedOff);
    };
    react_1.default.useEffect(() => {
        fetchAndSetNotificationTypesSettings();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [(0, jsx_runtime_1.jsx)(NotificationTypesTable_1.NotificationTypesTable, { notificationTypesSettings: notificationTypesSettings, isLoading: isLoading, onCheckboxChange: setTypePropertyValue }), (0, jsx_runtime_1.jsx)("div", { className: "flex-center m-xl", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { color: "brand", onClick: () => saveNotificationTypesSettings(notificationTypesSettings), loading: isLoading, children: (0, jsx_runtime_1.jsx)("span", { className: "m-l-xs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.buttons.saveChanges" }) }) }) }), (0, jsx_runtime_1.jsx)(elements_1.Separator, {}), (0, jsx_runtime_1.jsx)("div", { className: "flex-center m-l", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "default", onClick: turnOffAllNotifications, loading: isLoading, children: (0, jsx_runtime_1.jsx)("span", { className: "m-l-xs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.notification.unsubscribeAll" }) }) }) })] }));
}
